import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const desempenhoRepository = RepositoryFactory.get('desempenho');

const calculaCategoriaCds = (desempenho) => {
  if (desempenho.cds < 4) {
    return 'NAO_ATENDE';
  }
  if (desempenho.cds < 8) {
    return 'EM_DESENVOLVIMENTO';
  }
  return 'ATENDE';
};

const defaultDesempenho = {
  notaAgrupada: 0,
  notaAgrupadaResponsabilidade: 0,
  resultadosComportamentais: [],
  resultadosResponsabilidade: [],
  cds: 0,
  diagnostico: {},
};

const state = {
  desempenhos: [],
  desempenho: {
    ...defaultDesempenho,
  },
  desempenhoResponsabilidade: {
    ...defaultDesempenho,
  },
  loaded: false,
};

const actions = {
  load({ commit, state }, payload) {
    if (state.desempenhos.length > 0) {
      if (state.desempenhos[0].diagnostico.id !== payload.diagnostico.id) {
        commit('SET_LOADED', false);
      }
    }

    if (!state.loaded) {
      desempenhoRepository.getAll(payload.diagnostico.id, payload.comissao)
        .then((response) => {
          const desempenhos = response.data;
          if (desempenhos && desempenhos.length > 0) {
            desempenhos.sort((a, b) => a.usuario.nome.localeCompare(b.usuario.nome));
            commit('SET_DESEMPENHOS', desempenhos);
            commit('SET_DESEMPENHO_RESPONSABILIDADE', desempenhos[0]);
            commit('SET_LOADED', true);
          } else {
            commit('SET_DESEMPENHOS', []);
            commit('SET_DESEMPENHO', { ...defaultDesempenho });
            commit('SET_DESEMPENHO_RESPONSABILIDADE', { ...defaultDesempenho });
            commit('SET_LOADED', false);
          }
        });
    }
  },
  setDesempenho({ commit }, payload) {
    if (payload.perspectiva === 'COMPORTAMENTAL') {
      commit('SET_DESEMPENHO', payload.desempenho);
    } else if (payload.perspectiva === 'RESPONSABILIDADE') {
      commit('SET_DESEMPENHO_RESPONSABILIDADE', payload.desempenho);
    }
  },
  setLoadedStatus({ commit }, status) {
    commit('SET_LOADED', status);
  },
};

const mutations = {
  SET_DESEMPENHOS: (st, desempenhos) => {
    st.desempenhos = desempenhos.map((d) => ({
      ...d,
      cdsCategoria: calculaCategoriaCds(d),
    }));
  },
  SET_DESEMPENHO: (st, desempenho) => {
    st.desempenho = {
      ...desempenho,
      cdsCategoria: calculaCategoriaCds(desempenho),
    };
  },
  SET_DESEMPENHO_RESPONSABILIDADE: (st, desempenho) => {
    st.desempenhoResponsabilidade = desempenho;
  },
  SET_LOADED: (st, status) => {
    st.loaded = status;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
